/**
 * the main root directory that points to a FileSystemDirectory and his mode
 * @type {({valueType: string, itemprop: string} | {referenceToObj: Set<string>, itemprop: string})[]}
 */
export const PersistentFileSystemRootEntryRule = [
    {
        itemprop: 'mode',
        itemtype: { type: 'number' }
    },
    {
        itemprop: 'entry',
        itemtype: {
            type: 'referenceToObj',
            allowedTypes: new Set(['PersistentFileSystemDirectory'])
        }
    }
];
export const PersistentFileSystemChildrenListRule = [
    {
        itemprop: 'path',
        itemtype: { type: 'string' }
    },
    {
        itemprop: 'mode',
        itemtype: { type: 'number' }
    },
    {
        itemprop: 'content',
        itemtype: {
            type: 'referenceToObj',
            allowedTypes: new Set(['PersistentFileSystemDirectory', 'PersistentFileSystemFile'])
        }
    }
];
/**
 * used to represent BLOBs
 * @type {{name: string, rule: {referenceToBlob: boolean, itemprop: string}[], $type$: string}}
 */
export const PersistentFileSystemFileRecipe = {
    $type$: 'Recipe',
    name: 'PersistentFileSystemFile',
    rule: [
        {
            itemprop: 'content',
            itemtype: {
                type: 'referenceToBlob'
            }
        }
    ]
};
/**
 * the children field is Map<string, FileSystemDirectoryEntry> where string is the simple path e.g '/dir1' in the current directory
 * @type {{name: string, rule: {valueType: string, itemprop: string}[], $type$: string}}
 */
export const PersistentFileSystemDirectoryRecipe = {
    $type$: 'Recipe',
    name: 'PersistentFileSystemDirectory',
    rule: [
        {
            itemprop: 'children',
            itemtype: {
                type: 'bag',
                item: {
                    type: 'object',
                    rules: PersistentFileSystemChildrenListRule
                }
            }
        }
    ]
};
/**
 * the main data structure for the root entry
 * @type {{name: string, rule: {rule: RecipeRule[], itemprop: string}[], $type$: string}}
 */
export const PersistentFileSystemRootRecipe = {
    $type$: 'Recipe',
    name: 'PersistentFileSystemRoot',
    rule: [
        {
            itemprop: 'root',
            itemtype: {
                type: 'object',
                rules: PersistentFileSystemRootEntryRule
            }
        }
    ]
};
const PersistentFileSystemRecipes = [
    PersistentFileSystemDirectoryRecipe,
    PersistentFileSystemFileRecipe,
    PersistentFileSystemRootRecipe
];
export default PersistentFileSystemRecipes;
//# sourceMappingURL=PersistentFileSystemRecipes.js.map